import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const BOARDS_ICON_GRADIENT = 'navigationBoardsGradient';

const BoardsIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1146 2.69482C13.6787 2.69482 12.5146 3.85888 12.5146 5.29482V7.75333C12.5146 9.18927 13.6787 10.3533 15.1146 10.3533H18.6023C20.0382 10.3533 21.2023 9.18927 21.2023 7.75333V5.29482C21.2023 3.85888 20.0382 2.69482 18.6023 2.69482H15.1146ZM5.39785 14.6758C3.96191 14.6758 2.79785 15.8398 2.79785 17.2758V18.7052C2.79785 20.1411 3.96191 21.3052 5.39785 21.3052H8.88546C10.3214 21.3052 11.4855 20.1411 11.4855 18.7052V17.2758C11.4855 15.8398 10.3214 14.6758 8.88546 14.6758H5.39785ZM12.5146 14.1884C12.5146 12.7524 13.6787 11.5884 15.1146 11.5884H18.6023C20.0382 11.5884 21.2023 12.7524 21.2023 14.1884V18.7051C21.2023 20.141 20.0382 21.3051 18.6023 21.3051H15.1146C13.6787 21.3051 12.5146 20.141 12.5146 18.7051V14.1884ZM5.39785 2.69482C3.96191 2.69482 2.79785 3.85888 2.79785 5.29482V10.8406C2.79785 12.2766 3.96191 13.4406 5.39785 13.4406H8.88546C10.3214 13.4406 11.4855 12.2766 11.4855 10.8406V5.29482C11.4855 3.85888 10.3214 2.69482 8.88546 2.69482H5.39785Z"
      />
      <SPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1146 2.69482C13.6787 2.69482 12.5146 3.85888 12.5146 5.29482V7.75333C12.5146 9.18927 13.6787 10.3533 15.1146 10.3533H18.6023C20.0382 10.3533 21.2023 9.18927 21.2023 7.75333V5.29482C21.2023 3.85888 20.0382 2.69482 18.6023 2.69482H15.1146ZM5.39785 14.6758C3.96191 14.6758 2.79785 15.8398 2.79785 17.2758V18.7052C2.79785 20.1411 3.96191 21.3052 5.39785 21.3052H8.88546C10.3214 21.3052 11.4855 20.1411 11.4855 18.7052V17.2758C11.4855 15.8398 10.3214 14.6758 8.88546 14.6758H5.39785ZM12.5146 14.1884C12.5146 12.7524 13.6787 11.5884 15.1146 11.5884H18.6023C20.0382 11.5884 21.2023 12.7524 21.2023 14.1884V18.7051C21.2023 20.141 20.0382 21.3051 18.6023 21.3051H15.1146C13.6787 21.3051 12.5146 20.141 12.5146 18.7051V14.1884ZM5.39785 2.69482C3.96191 2.69482 2.79785 3.85888 2.79785 5.29482V10.8406C2.79785 12.2766 3.96191 13.4406 5.39785 13.4406H8.88546C10.3214 13.4406 11.4855 12.2766 11.4855 10.8406V5.29482C11.4855 3.85888 10.3214 2.69482 8.88546 2.69482H5.39785Z"
      />
      <defs>
        <linearGradient
          id={BOARDS_ICON_GRADIENT}
          x1="12"
          y1="23.9618"
          x2="5.00657"
          y2="1.36534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70B500" />
          <stop offset="1" stopColor="#DDEC34" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BoardsIconSvg;

const SPath = styled.path`
  fill: #a5aac5;

  ${onLightTheme`
    fill: rgb(var(--ln-content));
  `}

  .active && {
    fill: url(#${BOARDS_ICON_GRADIENT});
  }
`;
